import { render } from "./TrainingReport.vue?vue&type=template&id=5885c292"
import script from "./TrainingReport.vue?vue&type=script&lang=ts"
export * from "./TrainingReport.vue?vue&type=script&lang=ts"
script.render = render

export default script